import { Outlet } from 'react-router-dom';

/**
 * Root layout component - wraps all routes.
 *
 * Provides:
 * - Global error boundary (can be added if needed)
 * - Any app-wide layout concerns
 *
 * Currently minimal - serves as a placeholder for future enhancements
 * like global error handling or analytics.
 */
export function RootLayout() {
    return <Outlet />;
}
